module.exports = __webpack_public_path__ + "img/sy_1.abdbb432.png";